var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyTestSiren(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5876 7.6933C13.5876 4.54898 10.9964 2 7.79999 2C4.60359 2 2.01239 4.54898 2.01239 7.6933V13.904H13.588L13.5876 7.6933Z",
    fill: "#E32939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5328 7.78551C11.5328 5.7575 9.8616 4.11353 7.8 4.11353C5.7384 4.11353 4.0672 5.7575 4.0672 7.78551V12.2988H11.5332L11.5328 7.78551Z",
    fill: "#EF4452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.80002 6.4397C8.22882 6.4397 8.57682 6.78203 8.57682 7.20384V12.5218H7.02362V7.20384C7.02362 6.78203 7.37122 6.4397 7.80002 6.4397Z",
    fill: "#F56570"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.1736 12.2808H1.4264C1.19091 12.2808 1 12.4686 1 12.7002V14.1018C1 14.3335 1.19091 14.5213 1.4264 14.5213H14.1736C14.4091 14.5213 14.6 14.3335 14.6 14.1018V12.7002C14.6 12.4686 14.4091 12.2808 14.1736 12.2808Z",
    fill: "#333D4B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyTestSiren);
export default __webpack_public_path__ + "static/media/daily_test_siren.3adeb5296670eef506bfd119ccc0e323.svg";
export { ForwardRef as ReactComponent };